import React, { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import '../../CSS/PrivacyPolicy.css';

const prohibited = [
  'Content that boasts, praises or promotes past, present, or future crimes',
  'Unnecessary graphic details of crimes',
  "Yours or anyone else's legal paperwork including court documents, victim documents or official documents from government agencies",
  'Admissions of guilt for crimes you have not been convicted of',
  'Names of individuals other than yourself or the loved one you are speaking on behalf of',
  'Individual personal addresses of you or anyone else',
  'Names of victims, co-defendants, witnesses or perpetrators, nor names of specific correctional officers',
  'Content that encourages aggressive / angry words or actions directed at public officials, officers of the court, correctional officers, judges or any employee of the state',
  'Gang names, symbols, flags, logos or gestures',
  'Content that ridicules victims or their families',
  'Firearms or weapons of any kind including ammunition and / or accessories',
  'Content that depicts or promotes the usage of drugs and / or alcohol',
  'Content that solicits money or financial assistance for you, your loved one, or anyone at all',
  'Content that expresses, insinuates, or hints at the guilt of non-convicted citizens',
  'Explicit language',
  'Violent threats against any individual or entity of any kind',
  'Nudity or obscenity',
  'Content that equates to conspiracy theories',
  'Misinformation, lies or half-truths',
  'Personal medical records of you or anyone else',
  "Personal identity information such as bank account information, bank statements, social security numbers, driver's license or any other sensitive content of similar nature",
  'Personal login codes, names or passwords for you or anyone else',
  "Content that violates or infringes on someone else's legally held copyright, trademark, intellectual property or patent",
];

const integrityPoints = [
  {
    icon: '◈',
    text: '4DSPS expects every piece of information to contain authentic stories of truthfulness and honesty without lies, fabrications or exaggerations.',
  },
  {
    icon: '◈',
    text: '4DSPS reserves the right to inquire with family, friends, law enforcement and policymakers about the truthfulness of your story including generalizations and / or details pertaining to people, places, things, and situations.',
  },
  {
    icon: '◈',
    text: 'We understand that situational evidence is subjective and that there may be numerous views and opinions about the same incident. If however, 4DSPS discovers that any part of your story is false, your account will be suspended.',
  },
];

const PrivacyPolicy = () => {
  const navigate = useNavigate();

  useEffect(() => {
    window.scrollTo({
      top: 0,
      behavior: 'instant', // or 'smooth' if you want animation
    });
  }, []);

  return (
    <div className="pp-root" id="printTermsOfUse">
      {/* Page Hero */}
      <div className="pp-hero">
        <div className="pp-hero-inner">
          <button className="pp-back-btn" onClick={() => navigate(-1)}>
            ← Back
          </button>
          <span className="pp-hero-eyebrow">6BY7 Platform</span>
          <h1 className="pp-hero-title">Privacy Policy</h1>
          <p className="pp-hero-sub">
            Last Updated: <strong>September 18, 2025</strong>
          </p>
        </div>
        <div className="pp-hero-accent-bar" />
      </div>

      {/* Content */}
      <div className="pp-content">
        {/* Section 1 — Overview */}
        <section className="pp-section">
          <div className="pp-section-label">
            <span className="pp-dot" />
            Overview
          </div>
          <h2 className="pp-section-heading">Content-Share Guidelines &amp; Privacy Policy</h2>
          <p className="pp-paragraph">
            4DSPS is created in the spirit of peaceful civic engagement. We do not permit the use of
            bigoted language, anti-government or anti-law enforcement rhetoric or the provocation of
            violence of any kind. 4DSPS bears no tolerance for objectionable content or abusive
            users. We reserve the right to not post any information that we deem inappropriate or
            subversive to the spirit of our platform.
          </p>
        </section>

        <div className="pp-divider" />

        {/* Section 2 — Prohibited */}
        <section className="pp-section">
          <div className="pp-section-label">
            <span className="pp-dot pp-dot--warn" />
            Prohibited Content
          </div>
          <h2 className="pp-section-heading">Do Not Post, Upload, Stream, or Share</h2>
          <ul className="pp-list">
            {prohibited.map((item, i) => (
              <li key={i} className="pp-list-item">
                <span className="pp-list-icon">✕</span>
                <span>{item}</span>
              </li>
            ))}
          </ul>
        </section>

        <div className="pp-divider" />

        {/* Section 3 — Content Integrity */}
        <section className="pp-section">
          <div className="pp-section-label">
            <span className="pp-dot" />
            Standards
          </div>
          <h2 className="pp-section-heading">Content Integrity</h2>
          <div className="pp-integrity-cards">
            {integrityPoints.map((pt, i) => (
              <div className="pp-card" key={i}>
                <span className="pp-card-icon">{pt.icon}</span>
                <p className="pp-paragraph">{pt.text}</p>
              </div>
            ))}
          </div>
        </section>

        {/* Footer stamp + Home button
        <div className="pp-footer-stamp">
          <span className="pp-stamp-brand">6BY7</span>
          <span className="pp-stamp-date">Policy effective: September 18, 2025</span>
          <button className="pp-home-btn" onClick={() => navigate('/')}>
            ⌂ Go to Home
          </button>
        </div> */}
      </div>
    </div>
  );
};

export default PrivacyPolicy;
